import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public apiPayLoad = {email: '', password: ''};
  public isResponseReceived = false;
  public isLoggedIn = false;

  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private loadingBar: LoadingBarService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken !== '' && accessToken !== undefined && accessToken !== null) {
      this.router.navigate(['/home']);
    }
  }

  doLogin(): void {
    this.loadingBar.start(0);

    // const headers = {'Authorization': 'Bearer my-token', 'Content-Type': 'application/json',};
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.http.post <any>('https://t2d.id8lab.net/api/login', this.apiPayLoad, httpOptions).subscribe(
      data => {
        console.log('user login info', data);
        localStorage.setItem('accessToken', data.access_token);

        this.spinner.hide();
        this.isLoggedIn = true;
        this.isResponseReceived = true;
        this.router.navigate(['/home']);
      },
      error => {
        console.error('There was an error!', error);
        this.isResponseReceived = true;
        this.spinner.hide();

      });
  }

}
